/* eslint-disable max-len */
import React from 'react';

const SizeSmallLeftIcon = props => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={19}
    height={19}
    viewBox="0 0 19 19"
    {...props}
  >
    <defs>
      <path
        id="small-size-left-path"
        d="M17 3.2v.6a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h10.6c.11 0 .2.09.2.2zm0 3v.6a.2.2 0 0 1-.2.2h-4.6a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2zm0 3v.6a.2.2 0 0 1-.2.2h-4.6a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2zm0 3v.6a.2.2 0 0 1-.2.2h-4.6a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2zm0 3v.6a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h10.6c.11 0 .2.09.2.2zM2.2 6h7.6c.11 0 .2.09.2.2v6.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2V6.2c0-.11.09-.2.2-.2zM3 7v5h6V7H3z"
      />
    </defs>
    <g fillRule="evenodd">
      <mask id="small-size-left-mask">
        <use xlinkHref="#small-size-left-path" />
      </mask>
      <use fillRule="nonzero" xlinkHref="#small-size-left-path" />
    </g>
  </svg>
);

export default SizeSmallLeftIcon;
